const dimensionColors = {
  dimension0: '#41867B',
  dimension1: '#DC5F18',
  dimension2: '#C28B00',
  dimension3: '#713251',
  dimension4: '#B65467',
  dimension5: '#224C4F',
  dimension6: '#A83624',
  dimension7: '#5C1F7A',
  dimension8: '#DF634D',
  dimensionPrimary: '#03172C',
}

const paletteColors = {
  paletteRed: '#B82A14',
  paletteOrange: '#D35105',
  paletteYellow: '#C28B00',
  paletteGreen: '#47855C',
  paletteBlueGreen: '#24666A',
  paletteLightBlue: '#1075A7',
  paletteDarkBlue: '#061A80',
  paletteMaroon: '#713251',
  palettePurple: '#6C237B',
  palettePink: '#B4076F',
  paletteBlack: '#212529',
  paletteLightGreen: '#72D494',
  paletteLighterBlue: '#49BAF2',
  paletteLightOrange: '#FF8138',
}

const statBoxColors = {
  statGreenPrimary: '#47845C',
  statGreenSecondary: '#8DB29B',
  statGreenLight: '#F8FBF9',
  statSteelBluePrimary: '#24666A',
  statSteelBlueSecondary: '#78A0A4',
  statSteelBlueLight: '#F3FCFD',
  statBluePrimary: '#1075A7',
  statBlueSecondary: '#6CA9C8',
  statBlueLight: '#F6FCFF',
  statPurplePrimary: '#061A80',
  statPurplelSecondary: '#6673B1',
  statPurplelLight: '#F4F6FF',
}

const paymentSatusColors = {
  paymentSuccess: statBoxColors.statGreenPrimary,
  paymentPending: statBoxColors.statBluePrimary,
  paymentFailed: paletteColors.paletteRed,
}

export const colors = {
  ...dimensionColors,
  ...paletteColors,
  ...statBoxColors,
  ...paymentSatusColors,
  resiliaBlue: '#003F7E',
  resiliaGreen: '#3ED865',
  resiliaWhite: '#FFFFFF',
  red: '#F6511D',
  yellow: '#FFC107',
  lightYellow: 'rgba(255, 193, 7, 0.1)',
  green: '#37BF59',
  darkGreen: '#47855C',
  coral: '#EB6864',
  blue: '#2EA3F2',
  lightBlue: '#B2CAE0',
  darkBlue: '#2992D9',
  greyBlue: '#33475B',
  navy: '#003263',
  darkGrey: '#68737B',
  mediumGrey: '#687378',
  grey: '#CED4DA',
  lightGrey: '#E4E4E4',
  lightestGrey: '#F2F2F2',
  black: '#212529',
  darkestBlack: '#000000',
  backgroundGrey: '#F6F7FA',
  lightestBlue: '#E8F0F6',
  lightBlueGrey: '#B2CAE0',
  resiliaPurple: '#713251',
  evergreen: '#376B49',
  skyBlue: '#299CD4',
  darkestBlue: '#00203F',
  mediumGreyBlue: '#808F9F',
  lightRed: '#FBF4F3',
  softGreen: '#41857B',
  earlyAccessYellow: '#FFD543',
  completedGreen: '#9BE19D',
  inProgressYellow: '#FFE085',
}
